'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gtagger = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GTAG_SCRIPT_BASE_URL = 'https://www.googletagmanager.com/gtag/js?id=';

var Gtagger = exports.Gtagger = function () {
  function Gtagger() {
    _classCallCheck(this, Gtagger);
  }

  _createClass(Gtagger, null, [{
    key: 'initialize',
    value: function initialize(trackingId) {
      if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
      }

      window.gtag = function () {
        window.dataLayer.push(arguments);
      };

      this.run('js', new Date());
      this.run('config', trackingId);

      try {
        (0, _loadScript2.default)('' + GTAG_SCRIPT_BASE_URL + trackingId);
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: 'run',
    value: function run() {
      try {
        var _window;

        (_window = window).gtag.apply(_window, arguments);
      } catch (error) {
        console.error(error);
      }
    }
  }]);

  return Gtagger;
}();

//# sourceMappingURL=index.js.map